/* global System */
// register component(s) with react habitat

export default {
  EventsList: () => System.import('./index'),
}
